import React from 'react'
import { PropTypes } from 'prop-types'
import { Provider } from 'react-redux'
import { Router } from 'react-router-dom'
import history from '../config/history'
import App from './layouts/App'

const Root = ({ store }) => (
  <Provider store={store}>
    <Router history={history}>
      <App />
    </Router>
  </Provider>
)

Root.propTypes = {
  store: PropTypes.object.isRequired,
}

export default Root



// WEBPACK FOOTER //
// ./src/views/Root.js